<template>
  <div class="page-column">
    <Header/>
    <MatchInfo />
    <MatchMenu />
    <MatchNotice />
    <Footer/>
  </div>
</template>

<script>
import Header from '@district/components/common/MatchHeader.vue'
import Footer from '@district/components/common/Footer'
import MatchInfo from '@comm/components/MatchInfo.vue'
import MatchMenu from '@comm/components/MatchMenu.vue'
import MatchNotice from '@comm/components/MatchNotice.vue'
export default {
  components: {
    Header,
    MatchInfo,
    MatchMenu,
    MatchNotice,
    Footer
  },
  data () {
    return {
    }
  },
  created () {
    window.scrollTo(0, 0)
  },
  mounted () {
    this.$bus.$emit('handleMenu',0,2)
  },
  methods: {
  },
  
}
</script>
<style lang="scss" scoped>
.page-column {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/district/views/project/components/Notice.vue